module.exports = __webpack_public_path__ + "static/media/Montserrat-SemiBold.c139ffb2.eot";